import "./files.css";
import { useMediaSrc } from "./media.tsx";
import { radius as radiusVar, type RadiusToken } from "./tokens.ts";

export type VideoProps = {
  src: string;
  /** Still shown before playback (e.g. the client-made thumbnail). */
  poster?: string;
  /** Accessible name (the file name). */
  title: string;
  width?: number;
  height?: number;
  radius?: RadiusToken;
  testID?: string;
};

/**
 * An inline video player with the platform's controls; streams with HTTP Range. Native: AVKit `VideoPlayer`
 * (AVURLAsset with the auth header) / Media3 `PlayerView` (ExoPlayer with an authenticated data source).
 */
export function Video({ src, poster, title, width, height, radius, testID }: VideoProps) {
  const url = useMediaSrc(src);
  const posterUrl = useMediaSrc(poster);
  const style = { borderRadius: radius === undefined ? undefined : radiusVar(radius), width, height: height === undefined ? undefined : height };
  if (url === undefined) return <div className="b-image-placeholder" style={style} data-testid={testID} />;
  return (
    // biome-ignore lint/a11y/useMediaCaption: user uploads carry no caption tracks.
    <video className="b-video" src={url} poster={posterUrl} title={title} aria-label={title} controls preload="metadata" playsInline style={style} data-testid={testID} />
  );
}
